module.exports = __webpack_public_path__ + "a7ad1c70835bd6dd02c27f2ce9483ad3.png";